<script setup lang="ts">
const menuItems = computed<Array<MenuItem>>(() => [{
  title: 'Kontakt',
  path: '/contact',
  show: true
}]);
const open = ref<boolean>(false);
const openList = ref<Object>({});
</script>

<template>
  <header>
    <nav class="navbar">
      <div id="logo">
        <NuxtLink href="/" class="scale-100 hover:scale-[1.05] ease-in duration-200">
          <div class="flex flex-row items-center gap-6">
            <span class="block w-[170px] h-[45px] bg-no-repeat bg-center bg-contain bg-[url(~/assets/img/logo.svg)] p-0 m-0" />
          </div>
        </NuxtLink>
        <button class="block sm:hidden" @click="open = !open">
          <svg
            class="fill-primary w-4 h-4 scale-100 hover:scale-125 ease-in duration-200"
            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 20 20"
            aria-hidden="true" role="img">
            <title>Menu</title>
            <path v-show="open"
              d="M18.278 16.864a1 1 0 01-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 01-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 011.414-1.414l4.829 4.828 4.828-4.828a1 1 0 111.414 1.414l-4.828 4.829 4.828 4.828z" />
            <path v-show="!open"
              d="M4 5h16a1 1 0 010 2H4a1 1 0 110-2zm0 6h16a1 1 0 010 2H4a1 1 0 010-2zm0 6h16a1 1 0 010 2H4a1 1 0 010-2z" />
          </svg>
        </button>
      </div>
      <ol id="menu" :class="[(open && 'opened'), ('list-image-none')]">
        <div v-for="item of menuItems.filter((item: MenuItem) => item.show)" :key="item.path">
          <li>
            <BaseLink :href="item.path" @click="item.click"
              :size="(['xl', '2xl'].includes(useNuxtApp()?.$styleSize?.value) ? useNuxtApp()?.$styleSize?.value : 'lg')"
              :disabled="item.disabled" :class-name="[
                'font-medium hover:text-slate-900',
                (!item.disabled && 'scale-100 hover:scale-[1.05] ease-in duration-200')
              ]">
              {{ item.title }}
            </BaseLink>
            <button v-if="item.items?.filter((subItem: MenuBase) => subItem.show)" class="text-slate-800"
              @click="openList[item.title] = !openList[item.title]">
              <svg class="fill-primary w-4 h-4 scale-100 hover:scale-125 ease-in duration-200"
                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 20 20"
                aria-hidden="true" role="img">
                <title>{{ item.title }}</title>
                <path v-show="openList[item.title]"
                  d="M18.278 16.864a1 1 0 01-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 01-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 011.414-1.414l4.829 4.828 4.828-4.828a1 1 0 111.414 1.414l-4.828 4.829 4.828 4.828z" />
                <path v-show="!openList[item.title]"
                  d="M4 5h16a1 1 0 010 2H4a1 1 0 110-2zm0 6h16a1 1 0 010 2H4a1 1 0 010-2zm0 6h16a1 1 0 010 2H4a1 1 0 010-2z" />
              </svg>
            </button>
          </li>
          <BaseCollapse v-if="item.items?.filter((subItem: MenuBase) => subItem.show)" v-model="openList[item.title]"
            class="open:animate-[down-fade-in_400ms_ease-in-out]">
            <li v-for="subItem of item.items?.filter((subItem: MenuBase) => subItem.show)" :key="subItem.path">
              <BaseLink :href="subItem.path" @click="subItem.click"
                :size="(['xl', '2xl'].includes(useNuxtApp()?.$styleSize?.value) ? useNuxtApp()?.$styleSize?.value : 'lg')"
                :class-name="[
                  'font-normal hover:text-slate-900',
                  (!subItem.disabled && 'scale-100 hover:scale-[1.05] ease-in duration-200')
                ]" :disabled="subItem.disabled">
                {{ subItem.title }}
              </BaseLink>
            </li>
          </BaseCollapse>
        </div>
      </ol>
    </nav>
  </header>
</template>

<style lang="scss" scoped>
.navbar {
  @apply m-1 flex flex-col;
  @apply sm:flex-row sm:justify-between sm:items-center;

  >#logo {
    @apply flex flex-row justify-between items-center;
  }

  >#menu {
    @apply flex flex-col overflow-hidden;
    @apply sm:flex-row sm:gap-5 sm:overflow-visible;

    @apply max-h-0 transition-[max-height] duration-1000;
    @apply sm:max-h-screen sm:transition-none sm:duration-0;

    &.opened {
      @apply max-h-screen transition-[max-height] duration-[2000ms] ease-in-out;

      /* Desktop */
      /* max-height: 100vh;
          transition: max-height 2s ease-in-out; */
    }

    >div {
      @apply border-b sm:border-0;

      &:last-child {
        @apply border-0;

        li {
          &:last-child {
            @apply mb-0;
          }
        }
      }

      li {
        @apply flex justify-between gap-2 my-1 sm:my-0;

        a,
        button {
          @apply p-0 px-1;
        }
      }

      &:last-child>li {
        @apply mb-0;
      }
    }
  }
}
</style>
